import { render, staticRenderFns } from "./CrudOverview.vue?vue&type=template&id=399c6dfa&scoped=true&"
import script from "./CrudOverview.vue?vue&type=script&lang=js&"
export * from "./CrudOverview.vue?vue&type=script&lang=js&"
import style0 from "./CrudOverview.vue?vue&type=style&index=0&id=399c6dfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399c6dfa",
  null
  
)

export default component.exports